import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, Form } from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import { get, put } from "../../../helpers/RequestHelper";

import CKEditor4 from "./../../../components/input/TextEditor";

import Sidebar from "./Sidebar";

function Step3() {
  const history = useHistory();
  let { questionId, answerKey } = useParams();
  answerKey = parseInt(answerKey);

  const [validated, setValidated] = useState(false);
  const [questionData, setQuestionData] = useState({});

  useEffect(() => {
    (async function () {
      setValidated(false);
      try {
        const question = await get(`/api/admin/question/${questionId}`);
        setQuestionData(question);
      } catch (err) {}
    })();
  }, [questionId, answerKey]);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    if (form.checkValidity() === false) {
      return;
    }
    const dataToSave = { ...questionData };
    (async () => {
      try {
        const correct_answers = dataToSave.correct_answers;
        if (!correct_answers[answerKey - 1]) {
          correct_answers[answerKey - 1] = 0;
        }

        dataToSave.correct_answers = correct_answers;

        await put(`/api/admin/question/${questionId}`, dataToSave);
        if (answerKey < questionData.answer_choice_count) {
          history.push(
            `/admin/question/edit/steps/step3/${questionId}/answer/${
              parseInt(answerKey) + 1
            }`
          );
        } else {
          history.push(`/admin/question/edit/steps/step4/${questionId}`);
        }
      } catch (err) {
        alert(err && err.message ? err.message : "Something went wrong");
      }
    })();
  };

  return (
    <Row>
      <Col md="3">
        <Sidebar
          currentStep={3}
          answerCount={questionData.answer_choice_count}
          questionId={questionData._id}
          optionNumber={answerKey}
        />
      </Col>
      <Col md="9">
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Card border="dark">
            <Card.Header>
              Provide Answers - Step 3 - (Option {answerKey})
              <div className="float-right">
                <Link
                  to={
                    answerKey === 1
                      ? `/admin/question/edit/steps/step2/${questionId}`
                      : `/admin/question/edit/steps/step3/${questionId}/answer/${
                          answerKey - 1
                        }`
                  }
                >
                  <Button variant="secondary">Back</Button>
                </Link>{" "}
                <Button variant="primary" type="submit">
                  Save &amp; Next
                </Button>
              </div>
            </Card.Header>
            {questionData._id ? (
              <Card.Body>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="question">
                    <Form.Label>Option {answerKey}</Form.Label>
                    <Form.Control
                      required
                      as="textarea"
                      value={questionData.answer_choices[answerKey - 1] || ""}
                      className="d-none"
                      onChange={() => {}}
                    />
                    <CKEditor4
                      data={questionData.answer_choices[answerKey - 1]}
                      onChange={(data) => {
                        const choices = questionData.answer_choices;
                        choices[answerKey - 1] = data;
                        setQuestionData({
                          ...questionData,
                          answer_choices: choices,
                        });
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Option is required
                    </Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group controlId="correct_answer">
                    <Form.Check
                      type="checkbox"
                      label="Is it correct answer?"
                      checked={
                        questionData.correct_answers[answerKey - 1]
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        const correct_answers = questionData.correct_answers;
                        correct_answers[answerKey - 1] = e.target.checked
                          ? 1
                          : 0;
                        setQuestionData({
                          ...questionData,
                          correct_answers: correct_answers,
                        });
                      }}
                    />
                  </Form.Group>
                </Form.Row>
              </Card.Body>
            ) : (
              ""
            )}
            <Card.Footer>
              <div className="float-right">
                <Link
                  to={
                    answerKey === 1
                      ? `/admin/question/edit/steps/step2/${questionId}`
                      : `/admin/question/edit/steps/step3/${questionId}/answer/${
                          answerKey - 1
                        }`
                  }
                >
                  <Button variant="secondary">Back</Button>
                </Link>{" "}
                <Button variant="primary" type="submit">
                  Save &amp; Next
                </Button>
              </div>
            </Card.Footer>
          </Card>
        </Form>
      </Col>
    </Row>
  );
}
export default Step3;
